<script>
import {
  required,
} from "vuelidate/lib/validators";
import { notify } from '@/helpers/notify' 
import Loader from "./../../../../components/widgets/loader.vue";

export default {
    components: {
        Loader,
    },
    page: {
        title: "Efatura İşlemleri",
    },
    data() {
        return {
            info: {},
            design: {},
            dataLoading:true,
            submitted:false,
        };
    },
    validations: {
        info:{
            username: { required },
            password: { required },
            ea_seri_no: { required },
            ef_seri_no: { required },
            source_urn: { required },
        },
        design:{
            address: { required },
            city: { required },
            companyname: { required },
            district: { required },
            email: { required },
            phonenumber: { required },
            taxoffice: { required },
            vkn: { required },
        }
    },
    mounted() {
        this.getList()
    },
    methods: {
        getList(){
            this.$http.get('/integrations/einvoice')
            .then(resp => {
                this.info = resp.data.info
                this.design = resp.data.design
            }) .catch(error => error)
            .finally(()=>this.dataLoading=false)
        },
        handleSubmit() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                this.$http.put('/integrations/einvoice', { info:this.info,design:this.design})
                .then(resp => {
                    notify.success(resp.data.message)
                }) .catch(error => error)
            }
            this.submitted = false;
        },
    }
};
</script>

<template>
<Loader :loading="true" :load="dataLoading">
    <div class="row">
        <div class="col-6">
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title"> Entagrasyon Bilgileri</h5>
                    <form class="needs-validation" @submit.prevent="handleSubmit">
                    <div class="row">
                        <div class="md-6">
                            <b-form-group
                                class="mb-3"
                                label="E-Fatura Seri Numarası"
                                label-cols-sm="5"
                            >
                                <b-form-input
                                    v-model="info.ef_seri_no"
                                    type="text"
                                    placeholder="E-Fatura Seri Numarası"
                                    :class="{
                                        'is-invalid': submitted && $v.info.ef_seri_no.$error,
                                    }"
                                ></b-form-input>
                                <div
                                    v-if="submitted && $v.info.ef_seri_no.$error"
                                    class="invalid-feedback"
                                    >
                                    <span v-if="!$v.info.ef_seri_no.required">Bu alan zorunludur.</span>
                                </div>
                            </b-form-group>
                            <b-form-group
                                class="mb-3"
                                label="E Arşiv Seri Numarası"
                                label-cols-sm="5"
                                >
                                <b-form-input
                                    v-model="info.ea_seri_no"
                                    type="text"
                                    placeholder="E Arşiv Seri Numarası"
                                    :class="{
                                        'is-invalid': submitted && $v.info.ea_seri_no.$error,
                                    }"
                                >
                                </b-form-input>
                                <div
                                    v-if="submitted && $v.info.ea_seri_no.$error"
                                    class="invalid-feedback"
                                    >
                                    <span v-if="!$v.info.ea_seri_no.required">Bu alan zorunludur.</span>
                                </div>
                            </b-form-group>
                            <b-form-group
                                class="mb-3"
                                label="Kullanıcı Adı"
                                label-cols-sm="5"
                                >
                                <b-form-input
                                    v-model="info.username"
                                    type="text"
                                    placeholder="Kullanıcı Adı"
                                    :class="{
                                        'is-invalid': submitted && $v.info.username.$error,
                                    }"
                                >
                                </b-form-input>
                                <div
                                    v-if="submitted && $v.info.username.$error"
                                    class="invalid-feedback"
                                    >
                                    <span v-if="!$v.info.username.required">Bu alan zorunludur.</span>
                                </div>
                            </b-form-group>
                            <b-form-group
                                class="mb-3"
                                label="Kullanıcı Şifresi"
                                label-cols-sm="5"
                                >
                                <b-form-input
                                    v-model="info.password"
                                    type="text"
                                    placeholder="Kullanıcı Şifresi"
                                    :class="{
                                        'is-invalid': submitted && $v.info.password.$error,
                                    }"
                                >
                                </b-form-input>
                                <div
                                    v-if="submitted && $v.info.password.$error"
                                    class="invalid-feedback"
                                    >
                                    <span v-if="!$v.info.password.required">Bu alan zorunludur.</span>
                                </div>
                            </b-form-group>
                            <b-form-group
                                class="mb-3"
                                label="Gönderici Birimi"
                                label-cols-sm="5"
                                >
                                <b-form-input
                                    v-model="info.source_urn"
                                    type="text"
                                    placeholder="Gönderici Birimi"
                                    :class="{
                                        'is-invalid': submitted && $v.info.source_urn.$error,
                                    }"
                                >
                                </b-form-input>
                                <div
                                    v-if="submitted && $v.info.source_urn.$error"
                                    class="invalid-feedback"
                                    >
                                    <span v-if="!$v.info.source_urn.required">Bu alan zorunludur.</span>
                                </div>
                            </b-form-group>
                            </div>
                            <div class="col-md-12">
                                <div class="mb-3 d-flex justify-content-end">
                                    <button class="btn btn-warning" type="submit">Güncelle</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="col-6">
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title">Fatura Dizayn Alanları</h5>
                    <form class="needs-validation" @submit.prevent="handleSubmit">
                    <div class="row">
                        <div class="md-6">
                            <b-form-group
                                class="mb-3"
                                label="Vergi Numarası"
                                label-cols-sm="5"
                            >
                                <b-form-input
                                    v-model="design.vkn"
                                    type="text"
                                    placeholder="Vergi Numarası" 
                                    :class="{
                                        'is-invalid': submitted && $v.design.vkn.$error,
                                    }"
                                ></b-form-input>
                                <div
                                    v-if="submitted && $v.design.vkn.$error"
                                    class="invalid-feedback"
                                    >
                                    <span v-if="!$v.design.vkn.required">Bu alan zorunludur.</span>
                                </div>
                            </b-form-group>
                            <b-form-group
                                class="mb-3"
                                label="Vergi Dairesi"
                                label-cols-sm="5"
                                >
                                <b-form-input
                                    v-model="design.taxoffice"
                                    type="text"
                                    placeholder="Vergi Dairesi"
                                    :class="{
                                        'is-invalid': submitted && $v.design.taxoffice.$error,
                                    }"
                                >
                                </b-form-input>
                                <div
                                    v-if="submitted && $v.design.taxoffice.$error"
                                    class="invalid-feedback"
                                    >
                                    <span v-if="!$v.design.taxoffice.required">Bu alan zorunludur.</span>
                                </div>
                            </b-form-group>
                            <b-form-group
                                class="mb-3"
                                label="Firma Ünvan"
                                label-cols-sm="5"
                                >
                                <b-form-input
                                    v-model="design.companyname"
                                    type="text"
                                    placeholder="Firma Ünvan"
                                    :class="{
                                        'is-invalid': submitted && $v.design.companyname.$error,
                                    }"
                                >
                                </b-form-input>
                                <div
                                    v-if="submitted && $v.design.companyname.$error"
                                    class="invalid-feedback"
                                    >
                                    <span v-if="!$v.design.companyname.required">Bu alan zorunludur.</span>
                                </div>
                            </b-form-group>
                            <b-form-group
                                class="mb-3"
                                label="İl"
                                label-cols-sm="5"
                                >
                                <b-form-input
                                    v-model="design.city"
                                    type="text"
                                    placeholder="İl"
                                    :class="{
                                        'is-invalid': submitted && $v.design.city.$error,
                                    }"
                                >
                                </b-form-input>
                                <div
                                    v-if="submitted && $v.design.city.$error"
                                    class="invalid-feedback"
                                    >
                                    <span v-if="!$v.design.city.required">Bu alan zorunludur.</span>
                                </div>
                            </b-form-group>
                            <b-form-group
                                class="mb-3"
                                label="İlçe"
                                label-cols-sm="5"
                                >
                                <b-form-input
                                    v-model="design.district"
                                    type="text"
                                    placeholder="İlçe"
                                    :class="{
                                        'is-invalid': submitted && $v.design.district.$error,
                                    }"
                                >
                                </b-form-input>
                                <div
                                    v-if="submitted && $v.design.district.$error"
                                    class="invalid-feedback"
                                    >
                                    <span v-if="!$v.design.district.required">Bu alan zorunludur.</span>
                                </div>
                            </b-form-group>
                            <b-form-group
                                class="mb-3"
                                label="Adres"
                                label-cols-sm="5"
                                >
                                <b-form-input
                                    v-model="design.address"
                                    type="text"
                                    placeholder="Adres"
                                    :class="{
                                        'is-invalid': submitted && $v.design.address.$error,
                                    }"
                                >
                                </b-form-input>
                                <div
                                    v-if="submitted && $v.design.address.$error"
                                    class="invalid-feedback"
                                    >
                                    <span v-if="!$v.design.address.required">Bu alan zorunludur.</span>
                                </div>
                            </b-form-group>
                            <b-form-group
                                class="mb-3"
                                label="Telefon"
                                label-cols-sm="5"
                                >
                                <b-form-input
                                    v-model="design.phonenumber"
                                    type="text"
                                    placeholder="Telefon"
                                    :class="{
                                        'is-invalid': submitted && $v.design.phonenumber.$error,
                                    }"
                                >
                                </b-form-input>
                                <div
                                    v-if="submitted && $v.design.phonenumber.$error"
                                    class="invalid-feedback"
                                    >
                                    <span v-if="!$v.design.phonenumber.required">Bu alan zorunludur.</span>
                                </div>
                            </b-form-group>
                            <b-form-group
                                class="mb-3"
                                label="E Posta"
                                label-cols-sm="5"
                                >
                                <b-form-input
                                    v-model="design.email"
                                    type="text"
                                    placeholder="E Posta"
                                    :class="{
                                        'is-invalid': submitted && $v.design.email.$error,
                                    }"
                                >
                                </b-form-input>
                                <div
                                    v-if="submitted && $v.design.email.$error"
                                    class="invalid-feedback"
                                    >
                                    <span v-if="!$v.design.email.required">Bu alan zorunludur.</span>
                                </div>
                            </b-form-group>
                            </div>
                            <div class="col-md-12">
                                <div class="mb-3 d-flex justify-content-end">
                                    <button class="btn btn-warning" type="submit">Güncelle</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</Loader>
</template>